import React from 'react';
import styles from "./Main.module.sass"
import {Header} from "../components/header/header";
import {StartSection} from "../components/startSection/startSection";
import {AboutSection} from "../components/aboutSection/aboutSection";
import {CatalogSection} from "../components/catalogSection/catalogSection";
import {OrderSection} from "../components/orderSection/orderSection";
import {ReviewSection} from "../components/reviewSection/reviewSection";
import {MapSection} from "../components/mapSection/mapSection";
import {Footer} from "../components/footer/footer";

export const Main = () => {
    return (
        <div>
            <Header></Header>
            <StartSection></StartSection>
            <AboutSection></AboutSection>
            <CatalogSection></CatalogSection>
            <OrderSection></OrderSection>
            <ReviewSection></ReviewSection>
            <MapSection></MapSection>
            <Footer></Footer>
        </div>
    );
};
